import React, { useState } from 'react';
import api from '../../../services/api';

type TipoAutorizacao = 'aac' | 'ami';

type Busca = { id?: number; numeroAutorizacaoCibio?: string };

const candidatosCodigo = (raw: string, prefixo: string): string[] => {
	const valor = raw.trim();
	if (!valor) return [];
	const candidatos: string[] = [];
	const adicionar = (item: string) => {
		const candidato = item.trim();
		if (candidato && !candidatos.includes(candidato)) candidatos.push(candidato);
	};
	adicionar(valor);
	adicionar(valor.replace(/\//g, '.'));
	adicionar(valor.replace(/\./g, '/'));
	const regex = new RegExp(`^${prefixo}\\s`, 'i');
	if (!regex.test(valor)) {
		adicionar(`${prefixo} ${valor}`);
		adicionar(`${prefixo} ${valor.replace(/\//g, '.')}`);
	}
	return candidatos;
};

const abrirPorId = async (tipo: TipoAutorizacao, id: number) => {
	const rota = tipo === 'aac' ? 'aac' : 'ami';
	window.open(`${window.location.origin}/autorizacoes/visualizar/${rota}?id=${id}`, '_blank');
};

const buscarId = async (tipo: TipoAutorizacao, codigo: string): Promise<number | null> => {
	const valor = codigo.trim();
	if (!valor) return null;

	if (/^\d+$/.test(valor)) {
		const id = parseInt(valor, 10);
		if (id > 0) {
			try {
				const recurso = tipo === 'aac' ? 'AtividadeContencao' : 'MovimentacaoInterna';
				const { data, status } = await api.get<{ id?: number }>(`api/v1/autorizacoes-cibio/${recurso}/${id}`);
				if (status === 200 && typeof data?.id === 'number') return data.id;
			} catch {
			}
		}
	}

	const prefixo = tipo === 'aac' ? 'AAC' : 'AMI';
	const recurso = tipo === 'aac' ? 'AtividadeContencao' : 'MovimentacaoInterna';
	const candidatos = candidatosCodigo(valor, prefixo);

	if (tipo === 'ami') {
		for (const texto of candidatos) {
			try {
				const { data } = await api.get<Busca[]>(`api/v1/autorizacoes-cibio/${recurso}/obterporfiltro?NumeroAutorizacaoCibio=${encodeURIComponent(texto)}`);
				const id = Array.isArray(data) ? data[0]?.id : (data as Busca | undefined)?.id;
				if (id) return id;
			} catch {
			}
		}
	}

	for (const texto of candidatos) {
		try {
			const { data } = await api.get<Busca[]>(`api/v1/autorizacoes-cibio/${recurso}/obterporfiltro?Codigo=${encodeURIComponent(texto)}`);
			const id = Array.isArray(data) ? data[0]?.id : (data as Busca | undefined)?.id;
			if (id) return id;
		} catch {
		}
	}

	return null;
};

export async function abrirAutorizacao(tipo: TipoAutorizacao, codigo: string): Promise<boolean> {
	const id = await buscarId(tipo, codigo);
	if (!id) {
		const nome = tipo === 'aac' ? 'AAC' : 'AMI';
		alert(`${nome} ${codigo.trim()} não encontrada no sistema.`);
		return false;
	}
	await abrirPorId(tipo, id);
	return true;
}

type LinkProps = {
	tipo: TipoAutorizacao;
	codigo?: string | null;
};

export default function LinkVisualizarAutorizacao({ tipo, codigo }: LinkProps) {
	const [buscando, setBuscando] = useState(false);
	const texto = String(codigo ?? '').trim();
	if (!texto) return null;

	const nome = tipo === 'aac' ? 'AAC' : 'AMI';

	return (
		<div style={{ marginTop: '4px' }}>
			<button
				type="button"
				className="btn btn-link p-0"
				disabled={buscando}
				onClick={() => {
					setBuscando(true);
					abrirAutorizacao(tipo, texto).finally(() => setBuscando(false));
				}}
			>
				{buscando ? `Buscando ${nome}...` : `Visualizar ${nome} ${texto}`}
			</button>
		</div>
	);
}
